<template>
  <div style="padding: 10px; min-height: 100px" v-loading="!pageData && loading">
    <div v-if="pageData">
      <div style="margin-bottom: 10px">
        <el-button :size="$xUISize" type="primary" @click="createClick">
          新建中心仓库
        </el-button>
        <el-button :size="$xUISize" :loading="pageData && loading" @click="refreshList">
          刷新
        </el-button>
      </div>
      <el-table
        lazy
        ref="table"
        :data="pageData"
        :load="loadChildren"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        @expand-change="handleExpandChange"
        row-key="guid"
      >
        <el-table-column prop="name" label="仓库/门店" min-width="220">
          <template slot-scope="scope">
            {{ scope.row.name }}
            <span
              v-if="!!scope.row.h5InventoryPwd"
              style="margin-left: 5px; color: #3399ff"
            >
              取货密码：{{ scope.row.h5InventoryPwd }}
            </span>
            <span
              v-if="scope.row.riderRewardAmount > 0"
              style="margin-left: 5px; color: red"
            >
              骑手红包：{{ scope.row.riderRewardAmount }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="guid" label="门店编号" width="220"> </el-table-column>
        <el-table-column prop="vetCompanyId" label="兽药" width="100">
          <template slot-scope="scope">
            {{ !!scope.row.vetCompanyId ? "1" : "0" }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="optControl" label="严控" width="100">
        </el-table-column> -->
        <el-table-column prop="optSort" label="排序" width="100"> </el-table-column>
        <el-table-column prop="action" label="操作" width="280" fixed="right">
          <template slot-scope="scope">
            <template v-if="scope.row.storehouseGuid == '0'">
              <el-link type="primary" @click="createChildrenClick(scope.row)">
                新建门店
              </el-link>
              <el-divider direction="vertical"></el-divider>
            </template>
            <el-link
              type="primary"
              v-if="!!scope.row.vetCompanyId"
              @click="bindVetClick(scope.row)"
            >
              编辑兽药账号
            </el-link>
            <el-link v-else type="primary" @click="bindVetClick(scope.row)">
              绑定兽药账号
            </el-link>
            <el-divider direction="vertical"></el-divider>
            <el-link type="primary" @click="editClick(scope.row)"> 编辑 </el-link>
            <!-- <el-divider direction="vertical"></el-divider>
            <el-link type="danger" @click="deleteClick(scope.row)">
              删除
            </el-link> -->
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 20px">
        <span style="color: #919191"> * 中心仓库为其周边门店供应货物，降低囤货成本 </span>
      </div>
    </div>
    <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
      <el-button v-if="errorMsg" @click="refreshList" size="small"> 重新加载 </el-button>
    </el-empty>
  </div>
</template>

<script>
import formPage from "./__store_info_form.vue";
import bindVetPage from "./__store_bind_vet.vue";

export default {
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      pageData: null,
      deleteLoading: false,
      currentParentGuid: null,
      tableTreeRefreshTool: {},
    };
  },
  methods: {
    bindVetClick(row) {
      this.$drawer.openDrawer(
        {
          title: "绑定兽药追溯账号",
          component: bindVetPage,
          refresh: () => {
            this.refreshByRow(row.storehouseGuid);
          },
          params: {
            storehouseGuid: row.storehouseGuid,
            guid: row.guid,
          },
        },
        true
      );
    },
    editClick(row) {
      this.$drawer.openDrawer(
        {
          title: "编辑门店/仓库信息",
          component: formPage,
          refresh: () => {
            this.refreshByRow(row.storehouseGuid);
          },
          params: {
            storehouseGuid: row.storehouseGuid,
            guid: row.guid,
          },
        },
        true
      );
    },
    deleteClick(row) {
      this.$confirm(`确定删除，此操作不可恢复，请谨慎操作?`, "提示", {
        type: "warning",
      }).then(() => {
        this.requestApi(
          "biz.customer.store.info.delete",
          {
            guid: row.guid,
          },
          { showError: true }
        ).then(() => {
          this.success("提交成功");
          this.$drawer.refreshDrawer();
          this.refreshByRow(row.storehouseGuid);
        });
      });
    },
    createChildrenClick(row) {
      this.$drawer.openDrawer(
        {
          title: "新建门店信息",
          component: formPage,
          refresh: () => {
            this.refreshByRow(row.guid);
          },
          params: {
            optStorehouse: 0,
            storehouseGuid: row.guid,
          },
        },
        true
      );
    },
    createClick() {
      this.$drawer.openDrawer(
        {
          title: "新建中心仓库",
          component: formPage,
          refresh: this.refreshList,
          params: {
            optStorehouse: 1,
          },
        },
        true
      );
    },
    loadChildren(tree, treeNode, resolve) {
      this.currentParentGuid = tree.guid;
      this.tableTreeRefreshTool[tree.guid] = {};
      this.tableTreeRefreshTool[tree.guid].resolve = resolve;
      this.tableTreeRefreshTool[tree.guid].expandCount = 0;
      this.requestApi("biz.customer.store.info.list", {
        optStorehouse: 0,
        storehouseGuid: tree.guid,
      })
        .then((resp) => {
          resolve(
            (resp.data.list || []).map((item) => {
              return Object.assign(
                {
                  hasChildren: item.childrenCount > 0,
                },
                item
              );
            })
          );
        })
        .catch((err) => {
          resolve([]);
        });
    },
    handleExpandChange(tree, expanded) {
      const curr = this.tableTreeRefreshTool[tree.guid];
      curr.expandCount++;
      curr.prevStatus = expanded;
      this.refreshChildrenList(tree.guid);
    },
    refreshChildrenList(storehouseGuid) {
      const curr = this.tableTreeRefreshTool[storehouseGuid];
      if (curr && curr.prevStatus) {
        this.requestApi("biz.customer.store.info.list", {
          storehouseGuid,
        })
          .then((resp) => {
            return resp.data.list || [];
          })
          .catch((err) => {
            return [];
          })
          .then((resp) => {
            this.$set(
              this.$refs.table.store.states.lazyTreeNodeMap,
              storehouseGuid,
              resp.map((item) => {
                return Object.assign(
                  {
                    hasChildren: item.childrenCount > 0,
                  },
                  item
                );
              })
            );
          });
      }
    },
    refreshList() {
      this.errorMsg = null;
      this.loading = true;
      return this.requestApi("biz.customer.store.info.list", {
        storehouseGuid: "0",
        optStorehouse: 1,
      })
        .then((resp) => {
          this.loading = false;
          this.pageData = (resp.data.list || []).map((item) => {
            return Object.assign({ hasChildren: item.childrenCount > 0 }, item);
          });
        })
        .catch((err) => {
          this.loading = false;
          this.errorMsg =
            (err && (err.msg || err.message)) || "连接服务器失败，请检查网络";
        });
    },
    refreshByRow(storehouseGuid) {
      this.refreshTool();
      this.refreshList();
      if (storehouseGuid) {
        this.refreshChildrenList(storehouseGuid);
      }
    },
    refreshTool() {
      (this.pageData || []).forEach((item) => {
        if (!item.hasChildren) {
          this.tableTreeRefreshTool[item.guid] = undefined;
          delete this.tableTreeRefreshTool[item.guid];
        }
      });
    },
  },
  mounted() {
    this.refreshTool();
    this.refreshList();
  },
};
</script>
